"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.87,2.08H15.05a2.6,2.6,0,0,0-5.1,0H3.13a.53.53,0,0,0-.53.53V24.47a.53.53,0,0,0,.53.53H21.87a.53.53,0,0,0,.53-.53V2.61A.53.53,0,0,0,21.87,2.08ZM4.54,23V4.1H20.46V23H4.54Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.59,9H8A.5.5,0,0,1,8,8h.54a.5.5,0,0,1,0,1Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17,9H10.66a.5.5,0,0,1,0-1H17a.5.5,0,0,1,0,1Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.59,12.36H8a.5.5,0,1,1,0-1h.54a.5.5,0,1,1,0,1Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17,12.36H10.66a.5.5,0,0,1,0-1H17a.5.5,0,0,1,0,1Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.59,15.7H8a.5.5,0,1,1,0-1h.54a.5.5,0,1,1,0,1Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17,15.7H10.66a.5.5,0,0,1,0-1H17a.5.5,0,0,1,0,1Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.59,19H8a.5.5,0,1,1,0-1h.54a.5.5,0,1,1,0,1Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17,19H10.66a.5.5,0,0,1,0-1H17a.5.5,0,0,1,0,1Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;